import React from "react";
import { useTranslation } from "react-i18next";

const VerifiedAccount = (props) => {
    const styles = props.styles;
    const { t } = useTranslation();

    return(
        <>  
            <p style={styles.tosContentLastChangedStyle}>{t('termsOfServicePage.lastChanged')}</p>
            <h3 style={styles.tosContentTitleStyle}>{t('termsOfServicePage.verifiedAccount.title')}</h3>
            <h4 style={styles.tosContentSubtitleStyle}>{t('termsOfServicePage.verifiedAccount.subtitle1')}</h4>
            <p style={styles.tosContentDescriptionStyle}>{t('termsOfServicePage.verifiedAccount.description')}</p>
            <ul >
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.verifiedAccount.termList.li1')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.verifiedAccount.termList.li2')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.verifiedAccount.termList.li3')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.verifiedAccount.termList.li4')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.verifiedAccount.termList.li5')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.verifiedAccount.termList.li6')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.verifiedAccount.termList.li7')}</p></li>
                <li style={styles.tosListBulletStyle}><p style={styles.tosContentDescriptionStyle}> {t('termsOfServicePage.verifiedAccount.termList.li8')}</p></li>
            </ul>
            <p style={styles.tosContentDescriptionStyle}><b>{t('termsOfServicePage.verifiedAccount.confirmation')}</b></p>
            <h3 style={styles.tosContentTitleStyle}>{t('termsOfServicePage.changesDisclaimer.title')}</h3>
            <p style={styles.tosContentDescriptionStyle}>{t('termsOfServicePage.changesDisclaimer.content.p1')}</p>
            <p style={styles.tosContentDescriptionStyle}>{t('termsOfServicePage.changesDisclaimer.content.p2')}</p>
            <p style={styles.tosContentDescriptionStyle}>{t('termsOfServicePage.changesDisclaimer.content.p3')}</p>
        </>
    )
}

export default VerifiedAccount